import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@sharedEnvironment/environment';
import { Observable } from 'rxjs';
import {CompraFoto, CompraFotoEntradasInfo, CompraFotoProceedToPayResponse, CompraFotoPayload} from "@lib/models/compra-foto.interface";
import { EventSummary } from '@lib/models/event-summary.interface';

const baseHeaders = new HttpHeaders({
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + environment.compraFotoTokenAPI,
});

@Injectable({
  providedIn: 'root'
})
export class CompraFotosService {

  private readonly baseUrl = `${environment.backAPI}/fotos`;

  constructor(readonly http: HttpClient) { }

  getUpcomingHomeGames(): Observable<EventSummary[]> {
    return this.http.get<EventSummary[]>(`${this.baseUrl}/entradas-home`, { headers: baseHeaders });
  }

  getEntradasInfoByEventId(eventId: number): Observable<CompraFotoEntradasInfo> {
    return this.http.get<CompraFotoEntradasInfo>(`${this.baseUrl}/entradas-info/eventId/${eventId}`, { headers: baseHeaders });
  }

  // Se permite parcial porque en la reserva inicial se envían placeholders de participantes
  persistCompra(payload: Partial<CompraFotoPayload>): Observable<CompraFoto> {
    return this.http.post<CompraFoto>(this.baseUrl + '/persist', payload, { headers: baseHeaders });
  }

  proceedToPay(payload: CompraFotoPayload & { id: number }, token: string): Observable<CompraFotoProceedToPayResponse> {
    const headers = baseHeaders.set('X-Compra-Token', token);
    return this.http.post<CompraFotoProceedToPayResponse>(`${this.baseUrl}/proceedToPay`, payload, { headers });
  }

  checkPalmerin(id: string | number, pin: string): Observable<any> {
    return this.http.post(`${environment.backAPI}/fotos/${id}/es-palmerin-valido`,
      { pin },
      { headers: baseHeaders }
    );
  }

  obtenerCompra(id: number, token: string): Observable<CompraFoto> {
    const headers = baseHeaders.set('X-Compra-Token', token);
    return this.http.get<CompraFoto>(`${this.baseUrl}/${id}`, { headers });
  }

  cancelarCompra(id: number, token: string): Observable<CompraFoto> {
    const headers = baseHeaders.set('X-Compra-Token', token);
    return this.http.post<CompraFoto>(`${this.baseUrl}/${id}/cancel`, {}, { headers });
  }

  cancelarCompraOnPageLeave(id: number, token: string): void {
    const url = `${this.baseUrl}/${id}/cancel`;

    fetch(url, {
      method: 'POST',
      keepalive: true,
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + environment.compraFotoTokenAPI,
        'X-Compra-Token': token,
      },
      body: '{}',
    }).catch(() => undefined);
  }

  keepAlive(id: number, token: string): Observable<CompraFoto> {
    const headers = baseHeaders.set('X-Compra-Token', token);
    return this.http.patch<CompraFoto>(`${this.baseUrl}/${id}/keep-alive`, {}, { headers });
  }


}
